import * as style from "ol/style";
import * as geom from "ol/geom";
import Alpine from "alpinejs";
import * as sphere from "ol/sphere";
import imageIcon from './../img/icon/image.svg';
import locationIcon from './../img/icon/location.svg';
import tradeIconGreen from './../img/icon/trade_green.svg';
import tradeIconRed from './../img/icon/trade_red.svg';
import avitoIcon from './../img/icon/avito.png';
import savedIcon from './../img/icon/saved.svg'
import adIcon from './../img/map-min/ad.svg';
import pharmacyIcon from './../img/map-min/pharmacy.svg';
import storeIcon from './../img/map-min/store.svg';
import beautyIcon from './../img/map-min/beauty.svg';
import childIcon from './../img/map-min/child.svg';
import eatIcon from './../img/map-min/eat.svg';
import schoolIcon from './../img/map-min/school.svg';
import healthIcon from './../img/map-min/health.svg';
import {getArea} from "ol/sphere";

const iconInfrastructure = {
    1: pharmacyIcon,
    2: storeIcon,
    3: beautyIcon,
    4: childIcon,
    5: eatIcon,
    6: schoolIcon,
    7: healthIcon,
};

let clusterIconCache = {};

function formatArea(polygon) {
    const area = getArea(polygon);
    return area > 1000000
        ? `${(area / 1e6).toFixed(2)} км²`
        : `${area.toFixed(1)} м²`;
}

const formatLength = function (line) {
    const length = sphere.getLength(line);
    let output;
    if (length > 1000) {
        output = Math.round((length / 1000) * 100) / 100 + ' ' + 'км';
    } else {
        output = Math.round(length * 100) / 100 + ' ' + 'м';
    }
    return output;
};

function formatNumberToText(num) {
    const million = Math.round(num / 1000000); // Округляем миллионы
    const thousand = Math.round((num % 1000000) / 1000); // Округляем тысячи
    const rest = num % 1000; // Оставляем остаток без округления

    let result = [];
    if (million > 0 && num >= 1000000) {
        result.push(`
            <tspan x="50%" dy="-0.4em">${million}</tspan>
            <tspan x="50%" dy="0.8em">млн</tspan>`
        );
    }
    else if (thousand > 0 && num >= 1000) {
        result.push(`
            <tspan x="50%" dy="-0.4em">${thousand}</tspan>
            <tspan x="50%" dy="0.8em">тыс.</tspan>`
        );
    }
    else if (rest > 0) {
        result.push(rest.toString())
    }


    return result.join(' ');
}

function formatPriceShort(num) {
    if (num >= 1000000) {
        const million = num / 1000000;
        return million % 1 === 0 ? `${million} млн` : `${million.toFixed(1)} млн`;
    } else if (num >= 1000) {
        const thousand = num / 1000;
        return thousand % 1 === 0 ? `${thousand} тыс` : `${thousand.toFixed(1)} тыс`;
    } else {
        return num.toString();
    }
}


export default {
    editGeometry: [
        new style.Style({
            fill: new style.Fill({
                color: 'rgba(11, 207, 255, 0.25)'
            }),
            stroke: new style.Stroke({
                color: '#0bcfff',
                width: 3,
            }),
            zIndex:999
        }),
        new style.Style({
            image: new style.Circle({
                radius: 4,
                fill: new style.Fill({
                    color: '#0bcfff'
                }),
                stroke: new style.Stroke({color: '#020fff', width: 1})
            }),
            zIndex:999,
            geometry: function (feature) {
                const coordinates = feature.getGeometry().getCoordinates()[0];
                return new geom.MultiPoint(coordinates);
            }
        })
    ],

    imageBox: [
        new style.Style({
            stroke: new style.Stroke({
                color: 'rgba(0, 0, 0, 0.8)',
                width: 1,
            }),
            fill: new style.Fill({
                color: 'rgba(255,255,255,0.01)'
            })
        })
    ],

    ownGeometry: function (feature) {
        let fill;
        if (feature?.getId() === Number(Alpine.store('MapData').makeGeometryId)) {
            fill = new style.Fill({
                color: 'rgba(11, 207, 255, 0.25)'
            })
        } else {
            let color = '#1C64F266';
            if (feature?.get('type') === 'zone') {
                color = 'rgba(255, 90, 31, 0.4)'
            }

            fill = new style.Fill({
                color: color
            })
        }

        return [
            new style.Style({
                fill: fill,
                stroke: new style.Stroke({
                    color: feature?.get('type') === 'zone' ? '#FF5A1F' : '#6D93FF',
                    width: 2,
                }),
                text: new style.Text({
                    font: '16px sans-serif',
                    fill: new style.Fill({
                        color: '#000'
                    }),
                    stroke: new style.Stroke({
                        color: '#fff',
                        width: 3
                    }),
                    offsetY:  -15,
                    text: feature.get('name'),
                }),
                image: new style.Circle({
                    radius: 5,
                    fill: new style.Fill({
                        color: '#0bcfff'
                    }),
                    stroke: new style.Stroke({color: '#020fff', width: 1})
                }),
                zIndex: 20,
            }),
            new style.Style({
                stroke: new style.Stroke({
                    color: '#0bcfff',
                    width: 2,
                }),
                image: new style.Circle({
                    radius: 6,
                    fill: new style.Fill({
                        color: '#0bcfff'
                    }),
                    stroke: new style.Stroke({color: '#020fff', width: 1})
                }),
                zIndex: 20,
                geometry: function (feature) {
                    if (feature?.getId() !== Alpine.store('MapData').makeGeometryId) {
                        return;
                    }
                    const coordinates = feature.getGeometry().getCoordinates();

                    if (feature?.getGeometry()?.getType() === 'Point') {
                        return new geom.Point(coordinates);
                    }

                    return new geom.LineString(coordinates[0]);
                }
            })
        ]
    },

    pointOverlayImage: new style.Style({
        image: new style.Icon({
            src: imageIcon,
            anchor: [0.5, 1], // точка привязки изображения
        }),
        fill: new style.Fill({
            color: 'rgba(243,243,243,0.8)'
        }),
        zIndex: 900
    }),

    pointSearch: new style.Style({
        image: new style.Icon({
            src: locationIcon,
            anchor: [0.5, 1], // точка привязки изображения
        }),
        zIndex: 900
    }),

    clusterStyleTb: function (feature) {
        const count = feature.get('count') || 1;
        let size = count > 999 ? 44 : count > 99 ? 36 : count > 9 ? 30 : count > 1 ? 30 : 16;
        const cacheKey = `${count}_${size}`;

        if (count === 1) {
            return new style.Style({
                image: new style.Icon({
                    src: feature.get('closed') ? tradeIconRed : tradeIconGreen,
                    scale: 1,
                })
            });
        }


        if (!clusterIconCache[cacheKey]) {
            const svg = `
            <svg class="icon-cluster-trade" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" xmlns="http://www.w3.org/2000/svg">
                <circle cx="${size / 2}" cy="${size / 2}" r="${size / 2 - 2}" stroke="#bad600" fill="#fff" stroke-width="2"/>` +
                (count > 1
                    ? `<text x="50%" y="50%" font-size="14" font-family="Proxima Nova Rg" fill="#000" font-weight="500" text-anchor="middle" dominant-baseline="central">
                        ${formatNumberToText(count)}
                    </text>`
                    : '')
            + `</svg>`;

            const svgBase64 = 'data:image/svg+xml;base64,' + btoa(String.fromCharCode(...new TextEncoder().encode(svg)));
            clusterIconCache[cacheKey] = new style.Style({
                image: new style.Icon({
                    src: svgBase64,
                    scale: 1,
                })
            });
        }

        return clusterIconCache[cacheKey];
    },


    clusterStyleAdRadius: function (feature) {
        const size = feature.get('features').length
        const imagePoint = new style.Icon({
            src: adIcon,
            anchor: [0.5, 0.5], // точка привязки изображения
        })

        const imageCluster = new style.Circle({
            radius: 11,
            fill: new style.Fill({ color: '#fff' }),
            stroke: new style.Stroke({ color: '#0099d6', width: 2 })
        })

        return new style.Style({
            image:  size > 1 ? imageCluster : imagePoint,
            text: size > 1 ? new style.Text({
                text: size.toString(),
                offsetY: 1,
                fill: new style.Fill({ color: '#333'}),
                font: '12px Arial'
            }) : null
        });
    },

    clusterStyleTbRadius: function (feature) {
        const size = feature.get('features').length
        let icon = tradeIconGreen;

        if (size === 1) {
            icon = feature.get('features')[0].get('closed') ? tradeIconRed : tradeIconGreen;
        }

        const imagePoint = new style.Icon({
            src: icon,
            anchor: [0.5, 1], // точка привязки изображения
        })

        const imageCluster = new style.Circle({
            radius: 11,
            fill: new style.Fill({ color: '#fff' }),
            stroke: new style.Stroke({ color: '#bad600', width: 2 })
        })

        return new style.Style({
            image:  size > 1 ? imageCluster : imagePoint,
            text: size > 1 ? new style.Text({
                text: size.toString(),
                offsetY: 1,
                fill: new style.Fill({ color: '#333'}),
                font: '12px Arial'
            }) : null
        });
    },

    clusterStyleAd: function (feature) {
        const features = feature.get('features');
        const size = features.length;

        if (size > 1) {
            const baseCircleStyle = new style.Circle({
                radius: 11,
                fill: new style.Fill({ color: '#007deb' }),
                stroke: new style.Stroke({ color: '#fff', width: 2 })
            });

            return new style.Style({
                image: baseCircleStyle,
                text: new style.Text({
                    text: size.toString(),
                    offsetY: 1,
                    fill: new style.Fill({ color: '#fff' }),
                    font: '12px Arial'
                })
            });
        } else if (size === 1) {
            const singleFeature = features[0];
            const price = singleFeature.get('price');

            if (price) {
                const num = parseFloat(price);
                const priceText = formatPriceShort(num);

                const textLength = priceText.length;
                const width = Math.max(50, textLength * 7.5 + 16);
                const height = 22;
                const radius = 11;

                const svg = `
                <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1" y="1" width="${width - 2}" height="${height - 2}" rx="${radius}" ry="${radius}"
                          fill="#007deb" stroke="#fff" stroke-width="2"/>
                    <text x="50%" y="50%" text-anchor="middle" dominant-baseline="middle"
                          fill="#fff" font-size="12" font-family="Arial">${priceText}</text>
                </svg>
            `;

                return new style.Style({
                    image: new style.Icon({
                        src: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg),
                        scale: 1,
                        anchor: [0.5, 0.5]
                    })
                });
            }
        }

        return null;
    },


    clusterStyleDeal: function (feature) {
        const size = feature.get('features').length;

        const baseCircleStyle = new style.Circle({
            radius: 11,
            fill: new style.Fill({ color: '#7F00FF' }),
            stroke: new style.Stroke({ color: '#fff', width: 2 })
        });

        return new style.Style({
            image: baseCircleStyle,
            text: size > 1 ? new style.Text({
                text: size.toString(),
                offsetY: 1,
                fill: new style.Fill({ color: '#fff' }),
                font: '12px Arial'
            }) : null
        });
    },

    clusterStyleSaved: function (feature) {
        const size = feature.get('features').length
        let icon = tradeIconGreen;

        if (size === 1) {
            icon = savedIcon;
        }

        const imagePoint = new style.Icon({
            src: icon,
            anchor: [0.5, 1], // точка привязки изображения
            scale: 26 / 52,
        })

        const imageCluster = new style.Circle({
            radius: 11,
            fill: new style.Fill({ color: '#FF5A1F' }),
            stroke: new style.Stroke({ color: '#fff', width: 2 })
        })

        return new style.Style({
            image:  size > 1 ? imageCluster : imagePoint,
            text: size > 1 ? new style.Text({
                text: size.toString(),
                offsetY: 1,
                fill: new style.Fill({ color: '#fff'}),
                font: '12px Arial'
            }) : null
        });
    },

    clusterStyleInfrastructure: function (feature) {
        const size = feature.get('features').length
        let icon = tradeIconGreen;

        if (size === 1) {
            const cat = feature.get('features')[0].get('cat')
            icon = iconInfrastructure[cat];
        }

        const imagePoint = new style.Icon({
            src: icon,
            anchor: [0.5, 0.5], // точка привязки изображения
        })

        const imageCluster = new style.Circle({
            radius: 15,
            fill: new style.Fill({ color: '#ffffff' }),
            stroke: new style.Stroke({ color: '#ff9547', width: 2 })
        })

        return new style.Style({
            image:  size > 1 ? imageCluster : imagePoint,
            text: size > 1 ? new style.Text({
                text: size.toString(),
                offsetY: 1,
                fill: new style.Fill({ color: '#000000'}),
                font: '16px Arial'
            }) : null
        });
    },

    makeKadnum: new style.Style({
        fill: new style.Fill({
            color: 'rgba(249, 249, 65, 0.4)'
        }),
        stroke: new style.Stroke({
            color: 'rgba(251, 251, 70, 1)',
            width: 2,
            lineCap: 'round', // Окончание линии закругленное
            lineJoin: 'round',
        }),
        image: new style.Icon({
            src: locationIcon,
            anchor: [0.5, 1], // точка привязки изображения
        }),
        zIndex: 10,
    }),

    createdGeometry: function (feature, intersection = null) {
        let polygon;
        let area;

        if (feature && feature.getGeometry().getType() === 'Polygon') {
            polygon = feature.getGeometry();
            area = Math.round(sphere.getArea(polygon)) + ' м²';
        }

        let styles =  [
            new style.Style({
                fill: new style.Fill({
                    color: 'rgba(11, 207, 255, 0.25)'
                }),
                stroke: new style.Stroke({
                    color: '#0bcfff',
                    width: 2,
                    lineCap: 'round', // Окончание линии закругленное
                    lineJoin: 'round',
                }),
                text: new style.Text({
                    text: area ? area : 0,
                    font: '12px Calibri,sans-serif',
                    fill: new style.Fill({
                        color: '#000',
                    }),
                    stroke: new style.Stroke({
                        color: '#fff',
                        width: 3,
                    }),
                }),
                image: new style.Circle({
                    radius: 5,
                    fill: new style.Fill({
                        color: '#0bcfff'
                    }),
                    stroke: new style.Stroke({color: '#020fff', width: 1})
                }),
            }), new style.Style({
                image: new style.Circle({
                    radius: 6,
                    fill: new style.Fill({
                        color: '#ffffff'
                    }),
                    stroke: new style.Stroke({color: 'rgba(28, 100, 242, 0.4)', width: 4})
                }),
                geometry: function (feature) {
                    if (feature.getGeometry().getType() !== 'Polygon') {
                        return;
                    }
                    const coordinates = feature.getGeometry().getCoordinates()[0];
                    return new geom.MultiPoint(coordinates);
                }
            }), new style.Style({
                fill: new style.Fill({
                    color: 'rgba(255,71,71,0.9)'
                }),
                stroke: new style.Stroke({
                    color: '#60ff0b',
                    width: 2,
                    lineCap: 'round', // Окончание линии закругленное
                    lineJoin: 'round',
                }),
                zIndex: 100,
                geometry: function () {
                    if (!intersection || Alpine.store('MapData').selectedGeometry.type !== 'polygon') {
                        return;
                    }

                    let coords = intersection.map(i => {
                        let c = i.getCoordinates();
                        c[0] = c[0].filter(p=>p.length)
                        return c
                    })

                    return new geom.MultiPolygon(coords);
                }
            })
        ]

        if (!polygon) {
            return styles;
        }
        let coordinates = polygon.getCoordinates()[0];

        for (let i = 0; i < coordinates.length - 1; i++) {
            const start = coordinates[i];
            const end = coordinates[i + 1];
            const segment = new geom.LineString([start, end]);
            const length = formatLength(segment);

            styles.push(
                new style.Style({
                    geometry: segment,
                    text: new style.Text({
                        text: length,
                        font: '12px Calibri,sans-serif',
                        fill: new style.Fill({
                            color: '#000',
                        }),
                        stroke: new style.Stroke({
                            color: '#fff',
                            width: 3,
                        }),
                        offsetY: -10,
                        placement: 'line',
                    }),
                })
            )
        }

        return styles;
    },

    drawPolygon: function (feature) {
        let polygon;
        let area;

        if (feature && feature.getGeometry().getType() === 'Polygon') {
            polygon = feature.getGeometry();
            area = Math.round(sphere.getArea(polygon)) + ' м²';
        }

        const styles = [
            new style.Style({
                fill: new style.Fill({
                    color: 'rgba(0,0,0,0.1)'
                }),
                text: new style.Text({
                    text: area ? area : 0,
                    font: '12px Calibri,sans-serif',
                    fill: new style.Fill({
                        color: '#000',
                    }),
                    stroke: new style.Stroke({
                        color: '#fff',
                        width: 3,
                    }),
                }),
                image: new style.Circle({
                    radius: 5,
                    fill: new style.Fill({
                        color: '#ffffff'
                    }),
                    stroke: new style.Stroke({
                        color: '#131313',
                        width: 1
                    })
                }),
            }),
            new style.Style({
                image: new style.Circle({
                    radius: 5,
                    fill: new style.Fill({
                        color: '#ffffff'
                    }),
                    stroke: new style.Stroke({
                        color: '#006fb8',
                        width: 1
                    })
                }),
                geometry: function(feature) {
                    const coordinates = feature.getGeometry().getCoordinates();
                    return new geom.MultiPoint(coordinates);
                }
            }),
        ];

        if (!polygon) {
            return styles;
        }

        let coordinates = polygon.getCoordinates()[0];

        for (let i = 0; i < coordinates.length - 1; i++) {
            const start = coordinates[i];
            const end = coordinates[i + 1];
            const segment = new geom.LineString([start, end]);
            const length = formatLength(segment);

            if (i === coordinates.length - 2) {
                styles.push(
                    new style.Style({
                        geometry: segment,
                        text: new style.Text({
                            text: length,
                            font: '12px Calibri,sans-serif',
                            fill: new style.Fill({
                                color: '#000',
                            }),
                            stroke: new style.Stroke({
                                color: '#fff',
                                width: 3,
                            }),
                            offsetY: -10,
                            placement: 'line',
                        }),
                    })
                )
                continue;
            }

            if (i === coordinates.length - 3) {
                styles.push(
                    new style.Style({
                        geometry: segment,
                        stroke: new style.Stroke({
                            color: '#0bcfff',
                            width: 3,
                            lineDash: [16, 16],
                        }),
                    })
                )
                continue;
            }

            styles.push(new style.Style({
                geometry: segment,
                stroke: new style.Stroke({
                    color: '#006fb8',
                    width: 3,
                    lineCap: 'round'
                }),
                text: new style.Text({
                    text: length,
                    font: '12px Calibri,sans-serif',
                    fill: new style.Fill({
                        color: '#000',
                    }),
                    stroke: new style.Stroke({
                        color: '#fff',
                        width: 3,
                    }),
                    offsetY: -10,
                    placement: 'line',
                }),
            }));
        }

        return styles;
    },


    ruler: function (feature) {
        const styles = [];
        const geometry = feature.getGeometry();

        if (!(geometry instanceof geom.LineString)) {
            return null;
        }

        const coordinates = geometry.getCoordinates();

        // Основной стиль для линии и точек
        styles.push(new style.Style({
            fill: new style.Fill({
                color: 'rgba(67,128,189,0.6)'
            }),
            stroke: new style.Stroke({
                color: '#0bcfff',
                width: 2,
            }),
            image: new style.Circle({
                radius: 5,
                fill: new style.Fill({
                    color: '#000000'
                })
            }),
        }));

        // Добавляем подписи к каждому отрезку
        for (let i = 0; i < coordinates.length - 1; i++) {
            const start = coordinates[i];
            const end = coordinates[i + 1];

            const segment = new geom.LineString([start, end]);
            const label = formatLength(segment); // длина в метрах
            const mid = [
                (start[0] + end[0]) / 2,
                (start[1] + end[1]) / 2
            ];

            styles.push(new style.Style({
                geometry: new geom.Point(mid),
                text: new style.Text({
                    text: label,
                    font: '12px Calibri,sans-serif',
                    fill: new style.Fill({ color: '#000' }),
                    stroke: new style.Stroke({ color: '#fff', width: 3 }),
                    overflow: true,
                })
            }));
        }

        return styles;
    },

    rulerPoly: function (feature) {
        const styles = [];

        if (!feature || feature.getGeometry().getType() !== 'Polygon') {
            return styles;
        }

        const polygon = feature.getGeometry();
        const coords = polygon.getCoordinates()[0];

        // Условие замкнутости: как минимум 4 точки и первая равна последней
        const isClosed = coords.length >= 4 &&
            coords[0][0] === coords[coords.length - 1][0] &&
            coords[0][1] === coords[coords.length - 1][1];

        // Добавляем заливку и текст площади только если замкнуто
        if (isClosed) {
            const area = Math.round(sphere.getArea(polygon)) + ' м²';

            styles.push(
                new style.Style({
                    fill: new style.Fill({
                        color: 'rgba(0,0,128,0.1)' // тёмно-синий фон
                    }),
                    text: new style.Text({
                        text: area,
                        font: '12px Calibri,sans-serif',
                        fill: new style.Fill({ color: '#000' }),
                        stroke: new style.Stroke({ color: '#fff', width: 3 }),
                    }),
                })
            );
        }

        // Рисуем сегменты — без последнего, если не замкнуто
        const limit = isClosed ? coords.length - 1 : coords.length - 1;

        for (let i = 0; i < limit - 1; i++) {
            const start = coords[i];
            const end = coords[i + 1];
            const segment = new geom.LineString([start, end]);
            const length = formatLength(segment);

            styles.push(new style.Style({
                geometry: segment,
                stroke: new style.Stroke({
                    color: '#003366',
                    width: 3,
                    lineCap: 'round'
                }),
                text: new style.Text({
                    text: length,
                    font: '12px Calibri,sans-serif',
                    fill: new style.Fill({ color: '#000' }),
                    stroke: new style.Stroke({ color: '#fff', width: 3 }),
                    offsetY: -10,
                    placement: 'line',
                }),
            }));
        }

        return styles;
    },



    drawPoint: new style.Style({
        fill: new style.Fill({
            color: 'rgba(67,128,189,0.6)'
        }),
        stroke: new style.Stroke({
            color: '#ff6333',
            width: 2
        }),
        image: new style.Circle({
            radius: 5,
            fill: new style.Fill({
                color: '#ff0000'
            })
        })
    }),

    drawZone: new style.Style({
        fill: new style.Fill({
            color: 'rgba(67,128,189,0.6)'
        }),
        stroke: new style.Stroke({
            color: '#ff6333',
            width: 2
        }),
        image: new style.Circle({
            radius: 5,
            fill: new style.Fill({
                color: '#ff0000'
            })
        })
    }),

    polygonRosreestr: new style.Style({
        image: new style.Circle({
            radius: 3,
            fill: new style.Fill({
                color: '#000ccf'
            })
        }),
        geometry: function(feature) {
            let coordinates = feature.getGeometry().getCoordinates()[0];
            return new geom.MultiPoint(coordinates);
        }
    }),

    pointMake: new style.Style({
        image: new style.Circle({
            radius: 6,
            fill: new style.Fill({
                color: '#000ccf'
            }),
            stroke: new style.Stroke({
                color: '#006fb8',
                width: 1
            })
        })
    })
}
